import { render } from "./EconomyPostPaymentsTable.vue?vue&type=template&id=48d900e4&ts=true"
import script from "./EconomyPostPaymentsTable.vue?vue&type=script&lang=ts"
export * from "./EconomyPostPaymentsTable.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__